import { ShieldCheck } from "lucide-react";

export function Logo({ size = 32, showText = true, textClass = "text-slate-900" }) {
  return (
    <div className="flex items-center gap-2.5" data-testid="tgc-logo">
      <div
        className="grid place-items-center rounded-xl bg-[#1E3A8A] text-white shadow-sm"
        style={{ width: size + 8, height: size + 8 }}
      >
        <ShieldCheck size={size - 4} strokeWidth={2.2} />
      </div>
      {showText && (
        <div className="leading-tight">
          <div className={`font-display font-bold text-[15px] ${textClass}`}>The Global Checks</div>
          <div className="text-[10px] tracking-[0.18em] uppercase text-slate-500 font-medium">Verification Services</div>
        </div>
      )}
    </div>
  );
}
